import type { FormField, FormSchema } from '@cli-types/core-engine/schema.js'

export function ensureFormFields(schema: FormSchema): FormField[] {
  if (!Array.isArray(schema.fields)) {
    schema.fields = []
  }
  return schema.fields
}
